import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { Player } from '@/lib/types/common/Player';
import { GameStep } from '@/lib/types/common/GameStep';
import LobbyPanel from './LobbyPanel';
import { PlayerRow } from './shared';
import { useTranslation } from '@/hooks/useTranslation';
import { IoWarningOutline } from 'react-icons/io5';

interface UnassignedPlayersPanelProps {
    players: { sessionId: string; player: Player; index: number }[];
    onAvatarClick: () => void;
    currentPlayerSessionId: string;
    gameStep: GameStep;
    gameMasterId: string;
    currentRound: number;
    currentHazards: string[];
    isInLobby: boolean;
}

const UnassignedPlayersPanel: React.FC<UnassignedPlayersPanelProps> = ({
    players,
    onAvatarClick,
    currentPlayerSessionId,
    gameStep,
    gameMasterId,
    currentRound,
    currentHazards,
    isInLobby,
}) => {
    const { t } = useTranslation();
    if (players.length === 0) return null;

    return (
        <LobbyPanel>
            <div
                className="absolute -top-4 left-2 text-red-400 text-shadow-border shadow-black text-lg flex items-center gap-1 font-orgon-plan font-bold text-nowrap"
            >
                <IoWarningOutline className="text-md xl:text-2xl" />
                <span className="text-[15px] xl:text-[20px]">{t('lobby.unassignedPlayers')}</span>
            </div>
            <div className="flex flex-col gap-2 md:gap-4 min-w-40">
                <AnimatePresence mode="popLayout">
                    {players.map(({ sessionId, player }) => (
                        <PlayerRow
                            key={sessionId}
                            sessionId={sessionId}
                            player={player}
                            isCurrentPlayer={sessionId === currentPlayerSessionId}
                            isInLobby={isInLobby}
                            gameStep={gameStep}
                            gameMasterId={gameMasterId}
                            currentRound={currentRound}
                            currentHazards={currentHazards}
                            onAvatarClick={onAvatarClick}
                        />
                    ))}
                </AnimatePresence>
            </div>
        </LobbyPanel>
    );
};

export default UnassignedPlayersPanel;
